import gql from 'graphql-tag'

import { CredentialsFieldsFragment } from 'main/gql/credentials'

export const CREATE_CREDENTIALS_MUTATION = gql`
  mutation CreateCredentials($email: String!, $password: String!) {
    credentials: createCredentials(email: $email, password: $password) {
      ...CredentialsFields
    }
  }

  ${CredentialsFieldsFragment}
`
